// Kuch Naya logo, brand guide v2.0 (Oct 2026).
// One type family for logo and UI: Anek. The wordmark is "कुछ नया" in Anek Devanagari ExtraBold
// with the sunflower-yellow dot as a full stop.
// Rule: the क icon (public/brand/kuchnaya-icon-*.svg) is ONLY the app icon and favicon.
// Wherever the name appears in the app, use the wordmark on its own. Never icon + wordmark together.
import { Link } from '../lib/router';

/** "कुछ नया" in Anek Devanagari ExtraBold, ending with the yellow dot. */
export function Wordmark({ size = 26, dark = false }: { size?: number; dark?: boolean }) {
  return (
    <span className={'wordmark' + (dark ? ' on-light' : '')} style={{ fontSize: size }} lang="hi">
      कुछ नया<span className="wordmark-dot" aria-hidden="true" />
    </span>
  );
}

export function Logo({ to = '/home', size = 34, dark = false }: { to?: string; size?: number; dark?: boolean }) {
  return (
    <Link to={to} className="logo" aria-label="Kuch Naya home">
      <Wordmark size={Math.round(size * 0.85)} dark={dark} />
    </Link>
  );
}

/** English label: KUCH NAYA in Anek Bold, 0.3em letter-spacing. */
export function BrandLabel() {
  return <span className="brand-label">KUCH NAYA</span>;
}
